import { useState } from "react";

export default function AdminLogin() {
  const [form, setForm]     = useState({ username: "", password: "" });
  const [error, setError]   = useState("");
  const [loading, setLoading] = useState(false);
  const [showPw, setShowPw] = useState(false);

  const handle = e => { setForm({ ...form, [e.target.name]: e.target.value }); setError(""); };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!form.username || !form.password) { setError("Both fields are required."); return; }
    setLoading(true);
    setError("");

    try {
      // Step 1 — get JWT token using plain fetch (no axios interceptors)
      const tokenRes = await fetch("https://sj-aroma-candles.onrender.com/api/token/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username: form.username, password: form.password }),
      });

      if (tokenRes.status === 401 || tokenRes.status === 400) {
        setError("Invalid username or password.");
        setLoading(false);
        return;
      }

      if (!tokenRes.ok) {
        setError("Server error. Make sure Django is running on port 8000.");
        setLoading(false);
        return;
      }

      const tokenData = await tokenRes.json();
      const token = tokenData.access;

      if (!token) {
        setError("Could not get access token. Please try again.");
        setLoading(false);
        return;
      }

      // Step 2 — verify this user is actually an admin
      const meRes = await fetch("https://sj-aroma-candles.onrender.com/api/users/me/", {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!meRes.ok) {
        setError("Could not verify admin status. Please try again.");
        setLoading(false);
        return;
      }

      const meData = await meRes.json();

      if (meData.role !== "admin" && !meData.is_staff && !meData.is_superuser) {
        setError("Access denied. This account does not have admin privileges.");
        setLoading(false);
        return;
      }

      // Success — store and redirect
      localStorage.setItem("admin_token", token);
      localStorage.setItem("admin_user", JSON.stringify(meData));
      window.location.href = "/admin/";

    } catch (err) {
      console.error("Admin login error:", err);
      setError("Cannot connect to server. Make sure Django is running on http://127.0.0.1:8000");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", background: "#f5f0e8", display: "flex", alignItems: "center", justifyContent: "center", padding: "24px", fontFamily: "Georgia, serif" }}>
      <div style={{ position: "fixed", inset: 0, background: "radial-gradient(ellipse at 30% 20%, rgba(224,123,57,.08) 0%, transparent 60%), radial-gradient(ellipse at 70% 80%, rgba(224,123,57,.06) 0%, transparent 60%)", pointerEvents: "none" }} />

      <div style={{ position: "relative", width: "100%", maxWidth: "400px" }}>
        {/* Logo */}
        <div style={{ textAlign: "center", marginBottom: "32px" }}>
          <div style={{ width: "52px", height: "52px", borderRadius: "14px", background: "linear-gradient(135deg, #e07b39, #c96a18)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 12px", boxShadow: "0 6px 20px rgba(201,106,24,.3)" }}>
            <svg width="22" height="24" viewBox="0 0 18 20" fill="none">
              <path d="M9 0C9 0 14 6 14 10.5C14 13.538 11.761 16 9 16C6.239 16 4 13.538 4 10.5C4 6 9 0 9 0Z" fill="white" opacity="0.9"/>
              <path d="M9 8C9 8 11.5 11 11.5 13C11.5 14.38 10.38 15.5 9 15.5C7.62 15.5 6.5 14.38 6.5 13C6.5 11 9 8 9 8Z" fill="#f5e6cc" opacity="0.75"/>
            </svg>
          </div>
          <h1 style={{ fontFamily: "Georgia, serif", fontSize: "20px", fontWeight: "700", color: "#1a1a1a", letterSpacing: "0.1em" }}>AROMA CANDLES</h1>
        </div>

        {/* Card */}
        <div style={{ background: "#fff", borderRadius: "18px", padding: "36px", boxShadow: "0 8px 40px rgba(0,0,0,.08)" }}>
          <h2 style={{ fontFamily: "Georgia, serif", fontSize: "18px", fontWeight: "700", color: "#1a1a1a", marginBottom: "6px", textAlign: "center" }}>Admin Portal</h2>
          <p style={{ fontFamily: "Georgia, serif", fontSize: "12px", color: "#aaa", textAlign: "center", marginBottom: "28px" }}>Sign in with your superuser credentials</p>

          {error && (
            <div style={{ background: "#fff0f0", border: "1px solid #f5c6cb", color: "#c0392b", borderRadius: "10px", padding: "10px 14px", marginBottom: "18px", fontFamily: "Georgia, serif", fontSize: "12px" }}>
              ⚠️ {error}
            </div>
          )}

          <form onSubmit={handleSubmit} noValidate style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            <div>
              <label style={{ display: "block", fontFamily: "Georgia, serif", fontSize: "10px", fontWeight: "700", color: "#aaa", letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: "6px" }}>Username</label>
              <div style={{ position: "relative" }}>
                <span style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", color: "#bbb", fontSize: "14px" }}>👤</span>
                <input name="username" value={form.username} onChange={handle}
                  placeholder="Enter your username" autoComplete="username"
                  style={{ width: "100%", padding: "11px 12px 11px 36px", borderRadius: "10px", border: "1.5px solid #e8d5b8", background: "#fffaf4", fontFamily: "Georgia, serif", fontSize: "13px", color: "#1a1a1a", outline: "none", boxSizing: "border-box" }} />
              </div>
            </div>

            <div>
              <label style={{ display: "block", fontFamily: "Georgia, serif", fontSize: "10px", fontWeight: "700", color: "#aaa", letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: "6px" }}>Password</label>
              <div style={{ position: "relative" }}>
                <span style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", color: "#bbb", fontSize: "14px" }}>🔒</span>
                <input name="password" type={showPw ? "text" : "password"} value={form.password} onChange={handle}
                  placeholder="••••••••" autoComplete="current-password"
                  style={{ width: "100%", padding: "11px 38px 11px 36px", borderRadius: "10px", border: "1.5px solid #e8d5b8", background: "#fffaf4", fontFamily: "Georgia, serif", fontSize: "13px", color: "#1a1a1a", outline: "none", boxSizing: "border-box" }} />
                <button type="button" onClick={() => setShowPw(v => !v)} tabIndex={-1}
                  style={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", fontSize: "14px", color: "#a07850", padding: 0 }}>
                  {showPw ? "🙈" : "👁️"}
                </button>
              </div>
            </div>

            <button type="submit" disabled={loading}
              style={{ width: "100%", padding: "13px", borderRadius: "12px", background: loading ? "#e0a870" : "linear-gradient(135deg, #e07b39, #c96a18)", color: "#fff", border: "none", cursor: loading ? "not-allowed" : "pointer", fontFamily: "Georgia, serif", fontSize: "13px", fontWeight: "700", letterSpacing: "0.08em", boxShadow: "0 4px 18px rgba(201,106,24,.3)" }}>
              {loading ? "Signing in..." : "Sign in to Dashboard →"}
            </button>
          </form>
        </div>

        <p style={{ fontFamily: "Georgia, serif", fontSize: "10px", color: "#bbb", textAlign: "center", marginTop: "20px" }}>
          © 2025 SJ AROMA CANDLES. Admin Portal.
        </p>
      </div>
    </div>
  );
}